import { render, staticRenderFns } from "./EventModalCatalogPackageForm.vue?vue&type=template&id=7be4b3b5&scoped=true"
import script from "./EventModalCatalogPackageForm.vue?vue&type=script&lang=js"
export * from "./EventModalCatalogPackageForm.vue?vue&type=script&lang=js"
import style0 from "./EventModalCatalogPackageForm.vue?vue&type=style&index=0&id=7be4b3b5&prod&lang=scss&scoped=true"
import style1 from "./EventModalCatalogPackageForm.vue?vue&type=style&index=1&id=7be4b3b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be4b3b5",
  null
  
)

export default component.exports